///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class PasswordResetInitService {
    private readonly baseUrl = 'api/account';

    constructor(private readonly http: HttpClient) {}

    save(mail: string): Observable<unknown> {
        let requestParamsUrl = '';

        if (!window.location.origin) {
            requestParamsUrl = `${window.location.protocol}//${window.location.hostname}${
                window.location.port ? ':' + window.location.port : ''
            }`;
        } else {
            requestParamsUrl = window.location.origin;
        }

        const requestParams = {
            mail,
            baseUrl: requestParamsUrl
        };

        return this.http.post(`${this.baseUrl}/reset-password/init`, requestParams);
    }
}
